var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.loadingfull)?_c('app-loading-full'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }